import * as _ from 'lodash';

import { ShapeFormat } from '../../wtFramework';

import { TagDateValue, Shape, ShapePointReference } from '../../models';
import { ILoggerService } from '../../services';

export interface DataPoint {
    x: TagDateValue;
    y: TagDateValue[];
    timeStamp: Date;
}

export interface IScatterPlotService {
    arrangeData(data: TagDateValue[], xSeries: any, series: any[]): DataPoint[];
    mapShapes(shapes: Shape[], data?: TagDateValue[], guidMap?: { [guid: string]: string }): ShapeFormat[];
}

export class ScatterPlotService implements IScatterPlotService {

    static serviceId = 'ScatterPlotService';
    static $inject = ['loggerService'];

    constructor(private _loggerService: ILoggerService) {
    }

    arrangeData(data: TagDateValue[], xSeries: any, series: any[]): DataPoint[] {
        const result: any[] = [];
        try {
            // #50148: Remove null points
            data = data.filter(d => d.value !== null);
            const createSeries = this.createYSeries(series);
            const grouped = _.groupBy(data, d => d.timeStamp);
            for (const key of Object.keys(grouped)) {
                const current = grouped[key];
                if (current.length > 1) {
                    const xData = _.find(current, v => xSeries?.selector && xSeries.selector(v) === xSeries.identifier);
                    if (xData) {
                        const dataPoint = {
                            x: xData,
                            y: createSeries(current),
                            timeStamp: new Date(key)
                        };
                        result.push(dataPoint);
                    }
                }
            }
        } catch (e) {
            this._loggerService.logError(e);
        }
        return result;
    }

    mapShapes(shapes: Shape[], data?: TagDateValue[], guidMap?: { [guid: string]: string }): ShapeFormat[] {
        if (!shapes || !shapes.length) {
            return [];
        }
        const result: ShapeFormat[] = shapes.map(s => {
            const fmt: ShapeFormat = {
                color: s.color,
                isLineVisible: s.isLineVisible,
                interpolate: s.interpolation,
                isFilled: s.isFilled,
                isSymbolVisible: s.isSymbolVisible,
                symbol: s.symbol,
                thickness: s.thickness ? s.thickness : 1,
                points: (s.points ? s.points : []).map(p => {
                    const x = this.getValue(p.x, data, guidMap);
                    const y = this.getValue(p.y, data, guidMap);
                    return {
                        x, y
                    };
                })
            };
            return fmt;
        });
        return result;
    }

    private getValue(p: ShapePointReference, data?: TagDateValue[], guidMap?: { [guid: string]: string }) {
        let value = null;
        switch (p.type) {
            case 'manual':
                value = p.value;
                break;
            case 'serie':
                if (data) {
                    const guid = guidMap && guidMap[p.seriesGuid] ? guidMap[p.seriesGuid] : p.seriesGuid;
                    const found = _.find(data, d => d.guid === guid && d.valueType === p.valueType);
                    if (found) {
                        value = found.value;
                    }
                }
                break;
        }
        return value;
    }

    private createYSeries(series: any[]) {
        const self = this;
        return (current: TagDateValue[]) => {
            const y: TagDateValue[] = [];
            series
                .filter(s => s.isXAxis)
                .concat(series.filter(s => !s.isXAxis))
                .forEach(s => {
                    try {
                        const m = _.find(current, c => s.selector && s.selector(c) === s.identifier);
                        if (m) {
                            y.push(m);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                });
            return y;
        };
    }
}